import { render, staticRenderFns } from "./KeyGroupEdit.vue?vue&type=template&id=0fd90c6e&"
import script from "./KeyGroupEdit.vue?vue&type=script&lang=ts&"
export * from "./KeyGroupEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports